import React from "react"
import PropTypes from "prop-types"
import { RichText } from "prismic-reactjs"

/**
 * Quote slice component
 */
const Quote = ({ slice }) => (
  <div className="post-part single container">
    <blockquote className="block-quotation">
      {RichText.asText(slice.primary.quote)}
    </blockquote>
  </div>
)

Quote.propTypes = {
  slice: PropTypes.shape({
    primary: PropTypes.shape({
      quote: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
}

export default Quote
